import {generateAsyncActionCreators} from '../core/reduxUtils'

const getCmsComponentActionCreators = generateAsyncActionCreators(
  'GET_CMS_COMPONENT',
  (cmsComponents) => ({
    cmsComponents
  }),
);

const getDeliveryTooltipsActionCreators = generateAsyncActionCreators(
  'GET_DELIVERY_TOOLTIPS',
  (params) => ({
    params
  }),
);

const actionCreators = {
  getCmsComponent: {
    ...getCmsComponentActionCreators,
  },
  getDeliveryTooltips: {
    ...getDeliveryTooltipsActionCreators
  }
}

export {
  actionCreators,
  getCmsComponentActionCreators,
  getDeliveryTooltipsActionCreators
};
